'use client';

import { useSuspenseQuery } from '@tanstack/react-query';

import { CacheKey } from '@eliadmin/core/src/api/constants';
import { fetchCountries } from '@eliadmin/core/src/api/general/general-api';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';

/** The store's countries – the query (and cache entry) of the core checkout and profile forms. */
export function useCountries() {
  const locale = useLocaleStore(s => s.currentLocale);

  return useSuspenseQuery({
    queryKey: [CacheKey.COUNTRIES, locale],
    queryFn: () => fetchCountries({ locale }),
    refetchOnWindowFocus: false,
  }).data.data;
}
